(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-product-detail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-product-details')) {
    customElements.define('bundle-product-details', class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => event.stopPropagation());
        this.addEventListener('keydown', (event) => event.stopPropagation());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-free-gifts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-free-gifts')) {
    customElements.define('product-free-gifts', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.syncQuantity = () => {
          const form = document.getElementById(this.dataset.formId);
          const quantity = this.getQuantity(form);
          this.querySelectorAll('[data-gift-quantity]').forEach((label) => {
            label.textContent = `× ${quantity}`;
          });
        };
        const onQuantityChange = (event) => {
          if (event.target.name === 'quantity' && event.target.form === document.getElementById(this.dataset.formId)) {
            this.syncQuantity();
          }
        };
        document.addEventListener('input', onQuantityChange, options);
        document.addEventListener('change', onQuantityChange, options);
        this.addEventListener('change', (event) => {
          if (event.target.matches('.product-free-gifts__variant-input')) {
            if (event.target.disabled) return;
            const option = event.target.closest('.product-free-gifts__option');
            this.updateVariant(option, event.target);
            option.querySelector('.product-free-gifts__radio').checked = true;
          }
          this.showError('');
        }, options);
        this.querySelectorAll('.product-free-gifts__variant-input:checked').forEach((input) => {
          this.updateVariant(input.closest('.product-free-gifts__option'), input);
        });
        this.syncQuantity();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      getQuantity(form) {
        return Math.max(1, parseInt(form?.elements.namedItem('quantity')?.value, 10) || 1);
      }

      updateVariant(option, input) {
        option.querySelector('.product-free-gifts__radio').value = input.value;
        option.querySelector('.product-free-gifts__variant').textContent = input.dataset.title;
        option.querySelector('[data-gift-price]').innerHTML = input.dataset.price;
        const badge = option.querySelector('[data-gift-badge]');
        if (badge) {
          badge.textContent = input.dataset.badge;
          badge.hidden = !input.dataset.badge;
        }
        const originalPrice = option.querySelector('[data-gift-original-price]');
        originalPrice.innerHTML = input.dataset.originalPrice;
        originalPrice.hidden = input.dataset.showOriginal !== 'true';
        const image = option.querySelector('.product-free-gifts__image');
        if (image && input.dataset.image) {
          image.src = input.dataset.image;
          image.removeAttribute('srcset');
        }
      }

      getCartItems() {
        const form = document.getElementById(this.dataset.formId);
        const mainInput = form?.querySelector('.main-product-variant-input');
        const selectedGift = this.querySelector('.product-free-gifts__radio:checked');
        if (!mainInput?.value || !selectedGift?.value || selectedGift.disabled) throw new Error(this.dataset.errorMessage);
        const quantity = this.getQuantity(form);
        const formData = new FormData(form);
        const mainItem = { id: mainInput.value, quantity };
        const properties = {};
        for (const [name, value] of formData.entries()) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = value;
        }
        if (Object.keys(properties).length) mainItem.properties = properties;
        if (formData.get('selling_plan')) mainItem.selling_plan = formData.get('selling_plan');
        const items = [mainItem];
        form.querySelectorAll('input[type="hidden"][name="id[]"]').forEach((input) => {
          if (input !== mainInput && !input.disabled && input.value) items.push({ id: input.value, quantity: 1 });
        });
        items.push({ id: selectedGift.value, quantity });
        this.showError('');
        this.syncQuantity();
        return items;
      }

      showError(message) {
        const error = this.querySelector('.product-free-gifts__error');
        error.textContent = message;
        error.hidden = !message;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-notify-modal"] && !Shopify.designMode) return;
  try {
    const notifyEmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  document.querySelectorAll('.product-notify-form').forEach((form) => {
    const emailInput = form.querySelector('[data-notify-email-input]');
    const emailError = form.querySelector('[data-notify-email-error]');
    const consentCheckbox = form.querySelector('[data-notify-consent]');
    const consentError = form.querySelector('[data-notify-consent-error]');
    const submitError = form.querySelector('[data-notify-submit-error]');
    const submitButton = form.querySelector('[type="submit"]');
    const variantInput = form.querySelector('[data-notify-variant-id]');
    if (!emailInput || !emailError || !consentCheckbox || !consentError || !submitError || !submitButton || !variantInput) return;

    let isSubmitting = false;

    const clearError = () => {
      emailError.textContent = '';
      emailError.hidden = true;
      emailInput.removeAttribute('aria-invalid');
    };

    const clearConsentError = () => {
      consentError.textContent = '';
      consentError.hidden = true;
    };

    emailInput.addEventListener('input', () => {
      if (emailInput.getAttribute('aria-invalid') === 'true' && notifyEmailPattern.test(emailInput.value.trim())) {
        clearError();
      }
    });

    consentCheckbox.addEventListener('change', () => {
      if (consentCheckbox.checked) clearConsentError();
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (isSubmitting) return;

      const email = emailInput.value.trim();
      emailInput.value = email;

      if (!email || !notifyEmailPattern.test(email) || !emailInput.checkValidity()) {
        emailError.textContent = email ? emailInput.dataset.errorInvalid : emailInput.dataset.errorRequired;
        emailError.hidden = false;
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.focus();
        return;
      }

      clearError();
      if (!consentCheckbox.checked) {
        consentError.textContent = consentCheckbox.dataset.errorRequired;
        consentError.hidden = false;
        consentCheckbox.focus();
        return;
      }

      clearConsentError();
      submitError.hidden = true;
      submitError.textContent = '';

      const siteId = form.dataset.klaviyoSiteId.trim();
      const variantId = variantInput.value;
      if (!siteId || !/^\d+$/.test(variantId)) {
        submitError.textContent = form.dataset.subscriptionError;
        submitError.hidden = false;
        return;
      }

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` }
            }
          }
        }
      };

      isSubmitting = true;
      submitButton.disabled = true;

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(siteId)}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'revision': '2024-06-15'
            },
            body: JSON.stringify(payload)
          }
        );

        if (response.status !== 202) throw new Error(`Klaviyo subscription failed: ${response.status}`);

        const dialog = form.closest('[data-product-notify-dialog]');
        const buyNowButton = [...document.querySelectorAll('[data-notify-dialog-id]')]
          .find((button) => button.dataset.notifyDialogId === dialog?.id);
        if (buyNowButton) {
          // Keep confirmed subscriptions per variant for this page only.
          buyNowButton.notifySubscriptions ||= new Set();
          buyNowButton.notifySubscriptions.add(variantId);
          syncProductNotifySubscriptionState(buyNowButton);
        }
        dialog?.close();
        emailInput.value = '';
        consentCheckbox.checked = false;
        const successDialog = document.getElementById(`${dialog?.id}-success`);
        if (successDialog && !successDialog.open) successDialog.showModal();
      } catch (error) {
        console.error('Unable to subscribe to back in stock:', error);
        submitError.textContent = form.dataset.subscriptionError;
        submitError.hidden = false;
      } finally {
        isSubmitting = false;
        submitButton.disabled = false;
      }
    });

    submitButton.disabled = false;
  });

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-product-notify-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    const dialog = event.target.closest('[data-product-notify-dialog]');
    if (dialog && event.target === dialog) {
      dialog.close();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-support-list"] && !Shopify.designMode) return;
  try {
    const shippingMarketTimeZones = {
    US: 'America/New_York',
    GB: 'Europe/London',
    IE: 'Europe/Dublin',
    PT: 'Europe/Lisbon',
    ES: 'Europe/Madrid',
    FR: 'Europe/Paris',
    DE: 'Europe/Berlin',
    IT: 'Europe/Rome',
    NL: 'Europe/Amsterdam',
    BE: 'Europe/Brussels',
    AT: 'Europe/Vienna',
    PL: 'Europe/Warsaw',
    SE: 'Europe/Stockholm',
    FI: 'Europe/Helsinki',
    GR: 'Europe/Athens',
  };

  const updateEstimatedShippingDates = (root = document) => {
    root.querySelectorAll('[data-estimated-shipping]').forEach((row) => {
      const section = row.closest('section.product');
      const variantSelector = section?.querySelector('variant-radios');
      if (variantSelector?.currentVariant === null) {
        row.style.display = 'none';
        return;
      }
      const variantInput = section?.querySelector('.main-product-variant-input');
      const variantId = variantInput?.value || row.dataset.initialVariant;
      const source = row.closest('.support-details-lists')?.querySelector('[data-shipping-variants]');
      let shippingVariants;

      try {
        shippingVariants = source ? JSON.parse(source.textContent) : {};
      } catch (error) {
        shippingVariants = {};
      }

      const minDays = Number(row.dataset.minDays);
      const maxDays = Number(row.dataset.maxDays);
      if (shippingVariants[variantId] !== true || !Number.isFinite(minDays) || !Number.isFinite(maxDays)) {
        row.style.display = 'none';
        return;
      }

      const defaultTimeZone = 'Europe/Berlin';
      const marketTimeZone = shippingMarketTimeZones[row.dataset.country] || defaultTimeZone;
      let timeZone = row.dataset.timeZone || marketTimeZone;
      let marketDateFormatter;

      try {
        marketDateFormatter = new Intl.DateTimeFormat('en-US', {
          timeZone,
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        });
      } catch (error) {
        timeZone = marketTimeZone;
        marketDateFormatter = new Intl.DateTimeFormat('en-US', {
          timeZone,
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        });
      }

      const now = new Date();
      const marketParts = Number.isFinite(now.getTime())
        ? Object.fromEntries(marketDateFormatter.formatToParts(now).map((part) => [part.type, part.value]))
        : null;
      const fallbackDate = row.dataset.serverDate.split('-').map(Number);
      const year = marketParts ? Number(marketParts.year) : fallbackDate[0];
      const month = marketParts ? Number(marketParts.month) : fallbackDate[1];
      const day = marketParts ? Number(marketParts.day) : fallbackDate[2];
      const startDate = new Date(Date.UTC(year, month - 1, day + Math.min(minDays, maxDays), 12));
      const endDate = new Date(Date.UTC(year, month - 1, day + Math.max(minDays, maxDays), 12));
      const shippingDateFormatter = new Intl.DateTimeFormat(row.dataset.locale || 'en-US', {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
      });
      const dateRange = shippingDateFormatter.formatRange(startDate, endDate);
      row.querySelectorAll('[data-estimated-shipping-date]').forEach((element) => {
        element.textContent = `${row.dataset.label.trim()} ${dateRange}`;
      });
      row.style.display = '';
    });
  };

  updateEstimatedShippingDates();
  document.addEventListener('shopify:section:load', (event) => updateEstimatedShippingDates(event.target));
  document.addEventListener('change', (event) => {
    const section = event.target.closest('section.product');
    if (section && (event.target.matches('.main-product-variant-input') || event.target.closest('variant-radios'))) {
      updateEstimatedShippingDates(section);
    }
  });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateEstimatedShippingDates();
  });
  window.setInterval(updateEstimatedShippingDates, 60000);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
    const selector = event.target.closest('.variants-selector[role="button"]');
    if (!selector || event.target.closest('.bundle-detail')) return;
    if (selector.classList.contains('disabled')) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      selector.click();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
